import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import { ExternalLink } from "lucide-react";
import { adminDashboard, adminPicks } from "@/lib/adminApi";
import { AdminPickRow } from "@/pages/admin/AdminPickRow";

function Stat({ label, value, tone = "white", testid }) {
  const tones = { green: "text-[#00E676]", red: "text-[#EF4444]", white: "text-white" };
  return (
    <div className="card-mp p-5" data-testid={testid}>
      <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-slate-500">{label}</p>
      <p className={`mt-2 font-mono text-2xl font-bold tracking-tight ${tones[tone]}`}>{value}</p>
    </div>
  );
}

export default function AdminResults() {
  const { data } = useQuery({ queryKey: ["admin-dashboard"], queryFn: adminDashboard });
  const { data: settled } = useQuery({ queryKey: ["admin-picks", "settled"], queryFn: () => adminPicks({ view: "settled" }) });
  const s = data?.stats;

  return (
    <div data-testid="admin-results">
      <div className="flex flex-wrap items-end justify-between gap-4">
        <div>
          <p className="eyebrow mb-2">Real Money Printer Ledger</p>
          <h1 className="font-display text-3xl font-extrabold uppercase tracking-tight text-white sm:text-4xl">Results Overview</h1>
        </div>
        <Link to="/results" target="_blank" className="btn-outline !px-5 !py-2.5" data-testid="admin-results-public-link"><ExternalLink size={14} /> Public Results</Link>
      </div>
      <p className="mt-3 max-w-2xl text-sm text-slate-400">
        Computed live from settled real picks only — demo data is never included here. Public mode currently: <b className="text-white uppercase">{data?.data_mode}</b>.
      </p>

      {s && (
        <div className="mt-8 grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-6">
          <Stat label="Season Record" value={s.record} tone="green" testid="admin-results-record" />
          <Stat label="Win %" value={`${s.win_pct}%`} testid="admin-results-winpct" />
          <Stat label="Net Units" value={`${s.net_units > 0 ? "+" : ""}${s.net_units}U`} tone={s.net_units >= 0 ? "green" : "red"} testid="admin-results-units" />
          <Stat label="ROI" value={`${s.roi > 0 ? "+" : ""}${s.roi}%`} tone={s.roi >= 0 ? "green" : "red"} testid="admin-results-roi" />
          <Stat label="Last 10" value={s.last10} testid="admin-results-last10" />
          <Stat label="Units Staked" value={`${s.staked_units}U`} testid="admin-results-staked" />
        </div>
      )}

      <div className="mt-8 space-y-3">
        {settled?.picks.length === 0 && <div className="panel px-6 py-16 text-center text-sm text-slate-400" data-testid="admin-results-empty">No settled picks yet.</div>}
        {settled?.picks.map((p) => <AdminPickRow key={p.id} pick={p} />)}
      </div>
    </div>
  );
}
